import { SvgIcon, SvgIconProps } from "@mui/material";

export const FileUploadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12.5 1.667H5a1.667 1.667 0 0 0-1.667 1.666v13.334A1.667 1.667 0 0 0 5 18.333h10a1.667 1.667 0 0 0 1.667-1.666V5.833L12.5 1.667Z"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M11.667 1.667V5a1.667 1.667 0 0 0 1.666 1.667h3.334M10 10v5M12.5 12.5 10 10l-2.5 2.5"
      />
    </svg>{" "}
  </SvgIcon>
);
